import { EmissionSourceType } from "@service/shared/enums";
import { createContext, useContext } from "react";

/** The emission source whose data-entry page renders below; unset outside the CCF data-entry routes. */
export const DataEntryPageEmissionSourceContext = createContext<EmissionSourceType | undefined>(undefined);

export const useDataEntryPageEmissionSource = (): EmissionSourceType | undefined =>
  useContext(DataEntryPageEmissionSourceContext);
